/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProposalType {
  'Standard Kit' = 0,
  Flex = 1,
  Custom = 2,
  'Timberline Solar' = 3,
}
